import { FilterTypes } from '../constants';

export const getProcessedTableToolbarFiltersList = (filters, placeholder, inlineLabel = true) => (
  filters?.reduce((processedList, filter) => {
    if (Array.isArray(filter?.values)) {
      const {
        id, values, multiSelect, ...rest
      } = filter;
      processedList.push({
        id,
        ...rest,
        placeholder,
        showLabelInline: inlineLabel,
        items: values,
        withSearch: values?.length > 5,
        type: multiSelect ? FilterTypes.MULTI_FILTER : FilterTypes.SINGLE_FILTER,
      });
    } else if (FilterTypes.DATE_RANGE) {
      processedList.push({ ...filter });
    }

    return processedList;
  }, [])
);
